import React from "react"
import { chunk } from "lodash"
import { useBlocks } from "../../hooks/use-blocks"
import { Image } from "./image.email"

export function Gallery({ id }) {
  const { children, properties } = useBlocks(id)
  const columns = properties.columns || 1
  const groups = chunk(children, columns)

  const columnWidth = `${(1 / columns) * 100}%`

  return (
    <outlook-container width="500">
      <div
        style={{
          maxWidth: 800,
          margin: "0 auto"
        }}
      >
        <table
          style={{
            width: "100%"
          }}
        >
          {groups.map((group, i) => (
            <tr key={i}>
              {group.map(image => (
                <td
                  style={{
                    display: properties.columns === 1 ? "block" : "table-cell",
                    verticalAlign: "top",
                    maxWidth: 400,
                    width: columnWidth
                  }}
                  key={image.block_id}
                >
                  <Image
                    key={image.block_id}
                    data={image}
                    block_id={image.block_id}
                    properties={properties}
                  />
                </td>
              ))}
            </tr>
          ))}
        </table>
      </div>
    </outlook-container>
  )
}
